import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle, Warning, Lightning } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";

export default function OAuthCallback() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, error: "", ok: false, mpUserId: "" });

  useEffect(() => {
    const code = sp.get("code");
    const stateParam = sp.get("state");
    const mpError = sp.get("error");
    const errorDescription = sp.get("error_description");

    if (mpError) {
      setState({ loading: false, error: errorDescription || mpError, ok: false, mpUserId: "" });
      return;
    }
    if (!code || !stateParam) {
      setState({ loading: false, error: "Callback inválido — code/state ausente", ok: false, mpUserId: "" });
      return;
    }

    const expected = sessionStorage.getItem("vb_mp_oauth_state");
    const redirectUri = sessionStorage.getItem("vb_mp_oauth_redirect_uri") || `${window.location.origin}/oauth/mercadopago/callback`;
    if (expected && expected !== stateParam) {
      setState({ loading: false, error: "State não confere (anti-CSRF). Tente reconectar.", ok: false, mpUserId: "" });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/oauth/mercadopago/exchange", {
          code,
          state: stateParam,
          redirect_uri: redirectUri,
        });
        sessionStorage.removeItem("vb_mp_oauth_state");
        sessionStorage.removeItem("vb_mp_oauth_redirect_uri");
        toast.success("Mercado Pago conectado com sucesso!");
        setState({ loading: false, error: "", ok: true, mpUserId: data.mp_user_id });
        setTimeout(() => navigate("/app/settings"), 1800);
      } catch (e) {
        setState({ loading: false, error: errMsg(e, "Falha na troca do código"), ok: false, mpUserId: "" });
      }
    })();
  }, [sp, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--bg-base)" }}>
      <div className="card-flat p-10 max-w-md w-full text-center fadeUp" data-testid="oauth-callback-card">
        {state.loading ? (
          <>
            <Lightning size={48} color="var(--accent)" weight="duotone" className="mx-auto animate-pulse" />
            <div className="font-display font-black text-2xl mt-4">Conectando Mercado Pago…</div>
            <div className="text-white/60 mt-2 text-sm">Trocando authorization_code pelo access_token do seller.</div>
          </>
        ) : state.ok ? (
          <>
            <CheckCircle size={48} color="var(--success)" weight="fill" className="mx-auto" />
            <div className="font-display font-black text-2xl mt-4" data-testid="oauth-success">Conta conectada!</div>
            <div className="text-white/60 mt-2 text-sm">
              MP user id: <code className="text-[var(--accent)]">{state.mpUserId}</code>
            </div>
            <div className="text-white/40 mt-4 text-xs">Redirecionando para configurações…</div>
          </>
        ) : (
          <>
            <Warning size={48} color="var(--danger)" weight="fill" className="mx-auto" />
            <div className="font-display font-black text-2xl mt-4" data-testid="oauth-error">Não foi possível conectar</div>
            <div className="text-white/60 mt-2 text-sm break-all">{state.error}</div>
            <button
              onClick={() => navigate("/app/settings")}
              className="btn-primary mt-6"
              data-testid="oauth-back-settings"
            >
              Voltar para configurações
            </button>
          </>
        )}
      </div>
    </div>
  );
}
